var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectMultiple/components/Input/Input.tsx";
import React, { forwardRef, useMemo } from 'react';
import { SelectInputStyled, InputSelectWrapper, RenderSelectInputValueWrapper, LeftIconWrapper, RightIconWrapper, ArrowDown, HighlightOff } from '../../../Select/components/Input/Input.styled';
import { Tooltip } from '../../../Tooltip';
import { BubbleSelectMultiple } from '../BubbleSelectMultiple';
import { RenderSelectInputValue, RenderSelectInputValueText, TooltipScrollbar } from './Input.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Input = /*#__PURE__*/forwardRef(function Input({
  colorScheme = 'grey',
  icon,
  renderInputValue,
  lockSelect,
  hideInputIcon,
  onReset,
  arrowIconIsTurned,
  resettable,
  wrapperStyled,
  selectValue,
  getOptionLabel,
  endAdornment,
  ...inputProps
}, ref) {
  const renderInputValueResult = useMemo(() => renderInputValue === null || renderInputValue === void 0 ? void 0 : renderInputValue(inputProps.value), [inputProps.value, renderInputValue]);
  return /*#__PURE__*/_jsxs(InputSelectWrapper, {
    additionalStyles: wrapperStyled,
    disabled: inputProps.disabled,
    children: [icon && !inputProps.focused && /*#__PURE__*/_jsx(LeftIconWrapper, {
      disabled: inputProps.disabled,
      children: icon
    }), !inputProps.focused && selectValue.length > 0 && /*#__PURE__*/_jsx(RenderSelectInputValueWrapper, {
      colorScheme: colorScheme,
      disabled: inputProps.disabled,
      lock: lockSelect,
      children: /*#__PURE__*/_jsxs(RenderSelectInputValue, {
        colorScheme: colorScheme // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ,
        onClick: () => {
          var _current;

          return ref === null || ref === void 0 ? void 0 : (_current = ref.current) === null || _current === void 0 ? void 0 : _current.focus();
        } //TODO исправить типы
        ,
        disabled: inputProps.disabled,
        children: [selectValue.length ? /*#__PURE__*/_jsx(RenderSelectInputValueText, {
          children: getOptionLabel(selectValue[0])
        }) : '', selectValue.length > 1 && /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(TooltipScrollbar, {
            children: selectValue.map(getOptionLabel).slice(1).join(', ')
          }),
          children: /*#__PURE__*/_jsxs(BubbleSelectMultiple, {
            disabled: inputProps.disabled,
            children: ["+", selectValue.length - 1]
          })
        })]
      })
    }), renderInputValueResult && !inputProps.focused && selectValue.length > 0 && /*#__PURE__*/_jsx(RenderSelectInputValueWrapper, {
      colorScheme: colorScheme,
      disabled: inputProps.disabled,
      children: /*#__PURE__*/_jsx(RenderSelectInputValue, {
        colorScheme: colorScheme // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ,
        onClick: () => {
          var _current2;

          return ref === null || ref === void 0 ? void 0 : (_current2 = ref.current) === null || _current2 === void 0 ? void 0 : _current2.focus();
        } //TODO исправить типы
        ,
        disabled: inputProps.disabled,
        children: renderInputValueResult
      })
    }), /*#__PURE__*/_jsx(SelectInputStyled, { ...inputProps,
      placeholder: selectValue.length > 0 && !inputProps.focused ? '' : inputProps.placeholder,
      colorScheme: colorScheme,
      existIcon: Boolean(icon),
      lock: lockSelect,
      ref: ref
    }), /*#__PURE__*/_jsxs(RightIconWrapper, {
      disabled: inputProps.disabled,
      children: [!lockSelect && resettable && selectValue.length > 0 && !inputProps.disabled && !inputProps.focused && /*#__PURE__*/_jsx(HighlightOff, {
        onClick: onReset,
        disabled: inputProps.disabled,
        "data-test-id": endAdornment === null || endAdornment === void 0 ? void 0 : endAdornment.dataTestId
      }), !hideInputIcon && !lockSelect && /*#__PURE__*/_jsx(ArrowDown, {
        color: "#00003D",
        onClick: () => {
          if (inputProps.disabled) {
            return;
          }

          if (!arrowIconIsTurned) {
            var _current3;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;
            ref === null || ref === void 0 ? void 0 : (_current3 = ref.current) === null || _current3 === void 0 ? void 0 : _current3.focus(); //TODO исправить типы
          }
        },
        turned: Boolean(arrowIconIsTurned)
      })]
    })]
  });
});